import script from "./LbrxServicesDrawer.vue?vue&type=script&setup=true&lang=ts"
export * from "./LbrxServicesDrawer.vue?vue&type=script&setup=true&lang=ts"

import "./LbrxServicesDrawer.vue?vue&type=style&index=0&id=5afac356&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5afac356"]])

export default __exports__